import { useAttemptListener } from 'dev-masters-react-kit'
import {
  attemptCreatePlaylist,
  CreatePlaylistDTO,
} from '../../../utils/redux/playlistsSlice'
import { listenerMiddleware, store, useAppDispatch } from '../../../utils/redux/store'
import { useNavigate } from 'react-router-dom'
import { message } from 'antd'
import PlaylistForm from '../../../components/PlaylistForm/PlaylistForm'

interface Props {}
export default function NewPlaylist({}: Props) {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const isLoading = useAttemptListener({
    listenerMiddleware: listenerMiddleware,


    attempt: attemptCreatePlaylist,
    onFulfilled: () => {
      message.success('Playlist has been created successfully!')
      navigate('/music/playlists/all')
    },
  })

  function onFinish(values: CreatePlaylistDTO) {
    dispatch(attemptCreatePlaylist(values))
  }
  
  return (
    <>
      <PlaylistForm
        onFinish={onFinish}
        isLoading={isLoading}
      />
    </>
  )
}
